import { fromJS } from 'immutable';
import {
  ACCOUNT_ACTIVATION_FAIL,
  ACCOUNT_ACTIVATION_SUCCESS,
  CLEAR_NETWORK_ERROR,
  CONTACTLESS_AUTHENTICATION_FAIL,
  CONTACTLESS_AUTHENTICATION_SUCCESS,
  LOGOUT_SUCCESS,
  NETWORK_ERROR,
  PASSWORD_RESET_FAIL,
  PASSWORD_RESET_REQUEST_FAIL,
  PASSWORD_RESET_REQUEST_SUCCESS,
  PASSWORD_RESET_SUCCESS,
  START_LOADING,
  UNAUTHORIZED,
  USER_AUTHENTICATION_FAIL,
  USER_AUTHENTICATION_SUCCESS,
  WHOAMI_FAIL,
  WHOAMI_SUCCESS,
  PROFILE_UPDATE_FAIL,
  PROFILE_UPDATE_SUCCESS,
  GET_LIST_ACCESS_SUCCESS,
  GET_LIST_ACCESS_FAIL,
} from './actions';

import { GENERIC_ERROR } from 'constants/errors.constants';

import * as Sentry from '@sentry/react';

const initialState = fromJS({
  user: null,
  errors: {},
  loading: false,
  tokenAuthorized: false,
  // This allows the token to persist across browser refresh
  // We use the browser API directly since react-router is not available until
  // after the `initialState` has been set
  // React-router also adds a `state` key to `history.state`
  contactlessAuthToken: window.history?.state?.state?.auth,
  unauthorized: false,
  networkError: null,
});

function authenticationServiceReducer(state = initialState, action) {
  switch (action.type) {
    case START_LOADING:
      return state.set('loading', true).set('errors', fromJS({}));
    case WHOAMI_SUCCESS:
      return state.set('user', action.payload.user).set('loading', false).set('errors', fromJS({}));
    case WHOAMI_FAIL:
      window.localStorage.removeItem('api_token');
      return state.set('loading', false).set('errors', fromJS(action.payload.errors || GENERIC_ERROR));
    case CONTACTLESS_AUTHENTICATION_FAIL:
      Sentry.addBreadcrumb({
        category: 'auth',
        message: 'Customer contactless token exchange failed...',
        level: 'info',
      });
      return state.set('loading', false).set('errors', fromJS(action.payload.errors || GENERIC_ERROR));
    case CONTACTLESS_AUTHENTICATION_SUCCESS: {
      Sentry.addBreadcrumb({
        category: 'auth',
        message: `Customer received session token? ${String(Boolean(action.payload.token))}`,
        level: 'info',
      });

      return state
        .set('loading', false)
        .set('unauthorized', false)
        .set('contactlessAuthToken', action.payload.token)
        .set('tokenAuthorized', true);
    }
    case USER_AUTHENTICATION_SUCCESS: {
      window.localStorage.setItem('api_token', action.payload.token);

      return state.set('loading', false).set('unauthorized', false);
    }
    case USER_AUTHENTICATION_FAIL:
      return state
        .set('loading', false)
        .set('unauthorized', true)
        .set('errors', fromJS(action.payload.errors || GENERIC_ERROR));
    case LOGOUT_SUCCESS:
      try {
        window.localStorage.removeItem('api_token');
      } catch {}

      return state.set('loading', false).set('user', null).set('unauthorized', false).set('errors', fromJS({}));
    case PASSWORD_RESET_REQUEST_SUCCESS:
      return state.set('loading', false).set('errors', fromJS({}));
    case PASSWORD_RESET_SUCCESS:
      window.localStorage.removeItem('api_token');

      return state.set('loading', false).set('errors', fromJS({}));
    case UNAUTHORIZED:
      return state.set('unauthorized', true);
    case NETWORK_ERROR:
      return state.set('networkError', action.payload.errors);
    case CLEAR_NETWORK_ERROR:
      return state.set('networkError', null);
    case ACCOUNT_ACTIVATION_SUCCESS:
      return state.set('loading', false).set('user', null).set('errors', fromJS({}));
    case PROFILE_UPDATE_SUCCESS:
      return state.set('loading', false).setIn(['user', 'profile'], action.payload.userProfile);
    case GET_LIST_ACCESS_SUCCESS:
      return state;
    case GET_LIST_ACCESS_FAIL:
    case PASSWORD_RESET_REQUEST_FAIL:
    case PASSWORD_RESET_FAIL:
    case ACCOUNT_ACTIVATION_FAIL:
    case PROFILE_UPDATE_FAIL:
      return state.set('loading', false).set('errors', fromJS(action.payload.errors || GENERIC_ERROR));
    default:
      return state;
  }
}

export default authenticationServiceReducer;
